import React from 'react';
import automallLogoImage from '@stack/assets/images/consignment/caricarz-automall.png';
import understandConsignmentImage from '@stack/assets/images/consignment/understand-consignment-plan.jpg';

import { ConsignInner } from '../styles';

import { CONSIGNMENT_BENEFITS } from './settings';
import {
  BenefitGrid,
  BenefitIcon,
  BenefitItem,
  BenefitLabel,
  ConsignmentPlanImage,
  ConsignTitle,
  UnderstandConsignmentBand,
  UnderstandConsignmentContainer,
  UnderstandConsignmentHeader,
} from './styles';

/**
 * ===========================
 * MAIN
 * ===========================
 */
export const UnderstandConsignment: React.FC = () => {
  // ======================= HOOKS

  // ======================= STATE

  // ======================= EFFECTS

  // ======================= VARIABLES

  // ======================= VIEWS
  return (
    <UnderstandConsignmentBand>
      <ConsignInner>
        <UnderstandConsignmentContainer>
          <UnderstandConsignmentHeader>
            <img src={automallLogoImage.src} alt="CariCarz Automall" />
            <ConsignTitle>
              Understanding CariCarzAutomall Consignment Plan
            </ConsignTitle>
          </UnderstandConsignmentHeader>

          <ConsignmentPlanImage
            src={understandConsignmentImage.src}
            width={2553}
            height={3169}
            alt=""
          />

          <BenefitGrid>
            {CONSIGNMENT_BENEFITS.map((benefit, index) => (
              <BenefitItem key={index}>
                <BenefitIcon src={benefit.imageSrc} alt="" />
                <BenefitLabel>{benefit.label}</BenefitLabel>
              </BenefitItem>
            ))}
          </BenefitGrid>
        </UnderstandConsignmentContainer>
      </ConsignInner>
    </UnderstandConsignmentBand>
  );
};

/**
 * ===========================
 * EXPORTS
 * ===========================
 */
export default UnderstandConsignment;
